module.exports = __webpack_public_path__ + "static/media/enhanced-grain-CopperedOak.c4b34128.png";